import { Pipe, PipeTransform } from '@angular/core';
import { secondsToTime } from '@shared/utils';

@Pipe({
  name: 'secondsToTime',
  standalone: true
})
export class SecondsToTimePipe implements PipeTransform {
  transform(value: number): string {
    return secondsToTime(value);
  }
}
